module.exports = __webpack_public_path__ + "static/media/homem_r1_c1.a9b88c95.jpg";